import PropTypes from 'prop-types';
import { useNavigate } from 'react-router-dom';
import { ArrowLeft } from 'react-feather';
import {
  // Avatar,
  // Button,
  Box,
  Card,
  CardContent,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow
} from '@material-ui/core';

const ProductCard = ({ product, ...rest }) => {
  const navigate = useNavigate();
  // const handleDelivery = (id) => {
  //   navigate(`/app/notificationDetail/${id}`, { replace: true });
  // };
  const handleBack = () => {
    navigate('/app/customers', { replace: true });
  };
  return (
    <Card
      sx={{
        display: 'flex',
        flexDirection: 'column',
        height: '100%'
      }}
      {...rest}
    >
      <CardContent>
        <Box sx={{ minWidth: 1350 }}>
          <ArrowLeft onClick={handleBack} />
          <Table id="emp">
            <TableHead>
              <TableRow>
                <TableCell>Sno</TableCell>
                <TableCell>Comment</TableCell>
                <TableCell>Date</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {product.map((customer, index) => (
                <TableRow hover key={index[0]}>
                  <TableCell>{index + 1}</TableCell>
                  <TableCell>{customer.Comments}</TableCell>
                  <TableCell>{customer.date}</TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </Box>
      </CardContent>
    </Card>
  );
};

ProductCard.propTypes = {
  product: PropTypes.object.isRequired
};

export default ProductCard;
